import { APK_VARIANTS, ApkVariant } from '@/enums/apk'
import i18n from '@/libs/i18n'

/*
 * The Android app's builds (docs/API.md §3.2): tv-api reads package, version, min SDK and the
 * signing certificate from the APK itself; the variant follows from the signer.
 */

/** The upload limit (code 15 above it). */
export const APK_MAX_BYTES = 200 * 1024 * 1024

/**
 * A SHA-256 short enough to read, long enough to recognise — the first and last four bytes,
 * as apksigner and keytool write them: "1C:72:25:C0 … 18:8B:A1:FF". "" stays "" (a build
 * uploaded before tv-api read the signer).
 */
export const shortFingerprint = (hex: string): string => {
    if (hex.length < 16) return hex.toUpperCase()

    const bytes = (part: string) => part.toUpperCase().match(/../g)?.join(':') ?? ''

    return `${bytes(hex.slice(0, 8))} … ${bytes(hex.slice(-8))}`
}

/** A variant's label ("Standardna" / "Platformna"); an unknown one as it came. */
export const apkVariantLabel = (variant: string): string =>
    APK_VARIANTS.includes(variant as ApkVariant) ? i18n.global.t(`apk.variant_${variant}`) : variant
